
import { mockInventory } from "./mock-data/inventory";
import { mockMedicationRequests } from "./mock-data/requests";

const getInventory = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        result: "success",
        content: {
          data: mockInventory,
          total: mockInventory.length,
        },
      });
    }, 500);
  });
};

const getMedicationRequests = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                result: "success",
                content: {
                    data: mockMedicationRequests,
                    total: mockMedicationRequests.length,
                },
            });
        }, 500);
    });
};

const pharmacy = {
    getInventory,
    getMedicationRequests,
};

export default pharmacy; 